import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { css } from 'twin.macro';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { MdKeyboard } from 'react-icons/md';
import { Brand, Container, LoginButton, Navbar } from '@/components/Pages/styles/pageStyles';
import logo from '@/assets/logos/logo.svg';
import { isValidMongoId } from '@/_helpers';
import { Button } from 'react-bootstrap';

const Component = () => {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');
    const history = useHistory();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (!inputValue.trim()) {
            setError('Please enter a meeting code or link');
            return;
        }
        const errorMessage = 'Please enter a valid meeting code or link';
  

        const meetingInput = inputValue.trim();
        if (isValidMongoId(meetingInput)) {
            history.push(`/meet/${meetingInput}`);
        } else if (meetingInput.includes('/meet/')) {
            if (meetingInput.startsWith('http')) {
                window.location.href = meetingInput;
            } else if (meetingInput.startsWith('/meet/')) {
                history.push(meetingInput);
            } else {
                     setError(errorMessage);
            }
        } else {
            setError(errorMessage);
        }
    };

    return (
        <Container>
            <Navbar>
                <Brand to="/">
                    <img src={logo} alt="Optonome Logo" />
                    <span>Optonome</span>
                </Brand>
                <LoginButton to="/login">Login</LoginButton>
            </Navbar>

            <div
                css={css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                `}
            >
                <div
                    css={css`
                        width: 100%;
                        max-width: 600px;
                        background: white;
                        margin-top: 10rem;
                    `}
                >
                    <h1 style={{ color: '#6c757d', fontSize: '3.5rem', textAlign: 'center', marginBottom: '4rem' }}>
                        Conference and Meetings from anywhere
                    </h1>
                    <form onSubmit={handleSubmit}>
                        <div
                            css={css`
                                position: relative;
                                margin-bottom: 1.5rem;
                            `}
                        >
                            <div
                                css={css`
                                    position: relative;
                                    display: flex;
                                    align-items: center;
                                `}
                            >
                                <MdKeyboard
                                    css={css`
                                        position: absolute;
                                        left: 16px;
                                        color: #5f6368;
                                        font-size: 20px;
                                        z-index: 1;
                                    `}
                                />
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    placeholder="Enter meeting code or link"
                                    css={css`
                                        width: 100%;
                                        padding: 14px 16px 14px 48px;
                                        font-size: 16px;
                                        border: 1px solid #dadce0;
                                        border-radius: 8px;
                                        outline: none;
                                        transition:
                                            border-color 0.2s,
                                            box-shadow 0.2s;
                                        background: white;
                                        font-family: 'Google Sans', Roboto, Arial, sans-serif;
                                        color: #202124;

                                        &:focus {
                                            border-color: #50aeb0;
                                            box-shadow: 0 0 0 2px rgba(26, 150, 100, 0.2);
                                        }
                                    `}
                                />
                            </div>

                            {error && (
                                <div
                                    css={css`
                                        color: #d93025;
                                        font-size: 16px;
                                        margin-top: 8px;
                                        text-align: left;
                                    `}
                                >
                                    {error}
                                </div>
                            )}
                        </div>
                        <Button
                            css={css`
                                width: 100%;
                                background-color: #50aeb0;
                                color: white;
                                border: none;
                                border-radius: 8px;
                                padding: 14px 24px;
                                &:disabled {
                                    background-color: #e8eaed;
                                    color: #9aa0a6;
                                    cursor: not-allowed;
                                }
                            `}
                            disabled={!inputValue}
                            type="submit"
                        >
                            Join Meeting
                        </Button>
                    </form>
                </div>
            </div>
        </Container>
    );
};

const ConferenceLandingComponent = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);

export default ConferenceLandingComponent;
